/* Page requests */

import {GeojsonConv} from '@one-click-lca/3d-buildings-shared/features';

import {getAuthenticationToken} from 'App/features/user/userApi';

import * as restClient from '../../../clients/rest_client';
import getConfig from '../../../load_config';
import * as pagesConstants from '../../common/pages_constants';
import {handleErrors} from '../../common/pages_requests';

export function getPage(pageId) {
  return restClient.model(pagesConstants.PAGES_MODEL).fetch(pageId);
}

export function getItems(
  _currentListValue,
  {pageId, withBestFaisa = false, filters = {}, sortBy},
) {
  return restClient.model(pagesConstants.LIGHT_PROJECTGROUPS_MODEL).query(
    {
      filter: {...filters, page: {equals: pageId}},
      fields: withBestFaisa ? ['best_faisability'] : undefined,
      sortBy: sortBy || ['-modification_date'],
    },
    true,
  );
}

export function updatePage(page, input) {
  const config = getConfig();
  return fetch(`${config.apiOrigin}/pages/${page.hash}/`, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      Authorization: getAuthenticationToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...input,
    }),
  })
    .then(handleErrors)
    .then(response => response.json())
    .catch(error => {
      console.error('Request failed', error);
      throw error.message;
    });
}

export function createProjectInPage(geometry, page) {
  if (geometry.type === 'Polygon') {
    geometry = GeojsonConv.polygonToMultiPolygon(
      GeojsonConv.geometryToFeature(geometry),
    ).geometry;
  }
  const config = getConfig();
  // USR-400 D01: change to new API, when POST method is available
  return fetch(`${config.apiOrigin}/lightprojectgroups/`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: getAuthenticationToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      geometry,
      page: page.hash,
    }),
  })
    .then(handleErrors)
    .then(response => response.json())
    .catch(error => {
      console.error('Request failed', error);
      throw error.message;
    });
}

export function deletePage(page) {
  return restClient.model(pagesConstants.PAGES_MODEL).delete(page);
}
